export enum FeedbackType {
  FeedbackReceivedAsSeller = 'FeedbackReceivedAsSeller',
  FeedbackReceivedAsBuyer = 'FeedbackReceivedAsBuyer',
  FeedbackReceived = 'FeedbackReceived',
  FeedbackLeft = 'FeedbackLeft',
}
